import gql from "graphql-tag";

export default gql`
  query SearchIssuers(
    $query: String!
    $listingCountry: IssuerListingCountry
    $issuerType: IssuerType
    $narrowContextIssuer: String
    $narrowCriteria: [IssuerSearchNarrowCriteria!]
    $excludeIssuers: [ObjectID!]
  ) {
    searchIssuers(
      query: $query
      listingCountry: $listingCountry
      issuerType: $issuerType
      narrowContextIssuer: $narrowContextIssuer
      narrowCriteria: $narrowCriteria
      excludeIssuers: $excludeIssuers
    ) {
      _id
      name
      listingExchangeCode
      tickerSymbol
      tickerSymbols
      ... on AmericanIssuerSearchResultNode {
        sector
        industry
        industryGroup
        isReit
        isDepositoryReceipt
        numberOfEmployees
      }
      marketCapitalization {
        totalCapitalization
      }
      niceLogo {
        url
        geometry
        dominantColor
        colorPalette
      }
    }
  }
`;
